import { Component, Input, OnInit } from '@angular/core';
import { SettingDTO } from '../../../../services/api/api';
import { ToasterService, ToastType } from '../../../../services/toaster/toaster.service';
import { ModalService } from '../../../../services/gui/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from '../../../../services/permission.service';
import { WebSettingsService } from '../../../../services/client/web-settings.service';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'web-setting',
  templateUrl: './web-setting.component.html',
  styleUrls: ['./web-setting.component.scss'],
  standalone: false,
})
export class WebSettingComponent implements OnInit {
  @Input() key: string;
  @Input() setting: SettingDTO;
  @Input() control: FormControl;

  public labelMarker: string;

  constructor(
    private readonly toaster: ToasterService,
    private readonly modalService: ModalService,
    private readonly translate: TranslateService,
    private readonly webSettings: WebSettingsService,
    public readonly permissionService: PermissionService
  ) {}

  ngOnInit(): void {
    this.labelMarker = 'lang.clientManagement.settings.setting.' + this.key;
  }

  reset() {
    this.modalService
      .confirm({
        title: this.translate.instant('lang.clientManagement.settings.singleSetting.reset'),
        message: this.translate.instant('lang.clientManagement.settings.singleSetting.reset.infoText', {
          settingName: this.translate.instant(this.labelMarker),
        }),
        yes: this.translate.instant('lang.clientManagement.settings.singleSetting.resetAction'),
        no: this.translate.instant('lang.globals.cancel'),
      })
      .then((result: boolean) => {
        if (result) {
          this.webSettings.deleteSetting(this.key).then(newValue => {
            this.setting.value = newValue;
            this.control.setValue(newValue);
            this.toaster.toast(ToastType.SUCCESS, this.translate.instant('lang.clientManagement.settings.singleSetting.resetDone'));
          });
        }
      });
  }
}
